// import Swiper JS
import Swiper, { Navigation, Autoplay, EffectFade } from 'swiper';
//import SwiperAnimation from '@cycjimmy/swiper-animation';
//import "animate.css"

// import Swiper styles
import 'swiper/swiper-bundle.css';

const $ = window.jQuery;


const CategorySwiper = {

  init() {
    var $CategorySwiper = $(document).find('.categorySwiper');

    if (!$CategorySwiper.length)
      return;


  
    // configure Swiper to use modules
    Swiper.use([Navigation, Autoplay, EffectFade]);
    //   const swiperAnimation = new SwiperAnimation();
    const swiper = new Swiper(".categorySwiper", {
 
      slidesPerView: 4,
      spaceBetween: 50,
      loop: false,
      cache:false,
      infinit: false,
       autoplay: {
        delay: 2500,
        disableOnInteraction: false,
      }, 
      breakpoints: {
        0: {
          slidesPerView: 1,
          spaceBetween: 20,
        },
        450: {
          slidesPerView: 1,
          spaceBetween: 20,
        },
        550: {
          slidesPerView: 2,
          spaceBetween: 30,
        },
        768: {
          slidesPerView: 3,
          spaceBetween: 15,
        },
        1024: {
          slidesPerView: 4,
          spaceBetween: 15,
        },
        1280: {
          slidesPerView:4,
          spaceBetween: 15,
        },
      },
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },

    });





  },

};

export default CategorySwiper;
